var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-20 w-400"},[_c('h2',[_vm._v("Dev Menu")]),_c('HMButton',{staticClass:"mt-20",on:{"click":_vm.demoResetSurveyTimestamps}},[_vm._v(" Demo - Reset Survey Timestamps ")]),_c('HMButton',{staticClass:"mt-20",attrs:{"color":"transparent"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" Exit ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }